import { useMediaQuery } from "@mui/system"


export function useIsMobile() {
    const width = '(max-width:500px)'
    const isMobile = useMediaQuery(width)
    return isMobile
}

export function useIsWebView() {
    const isApp = window.ReactNativeWebView ? true : false
    return isApp
}